// extracted by mini-css-extract-plugin
module.exports = {"usingBtn":"style_usingBtn__RVg5Z","customButton":"style_customButton__szqvp"};